<template>
  <div class="chatbox chatbox--tray chatbox--empty" id="chat-section">
    <div class="chatbox__title" @click="toggleChat">
      <h5>
        <a href="#">{{ specialist_consultant ? specialist_consultant : $store.getters.t('specialist_consultant') }}</a>
      </h5>
      <button class="chatbox__title__tray">
        <span></span>
      </button>
      <button class="chatbox__title__close">
            <span>
                <svg viewBox="0 0 12 12" width="12px" height="12px">
                    <line stroke="#FFFFFF" x1="11.75" y1="0.25" x2="0.25" y2="11.75"></line>
                    <line stroke="#FFFFFF" x1="11.75" y1="11.75" x2="0.25" y2="0.25"></line>
                </svg>
            </span>
      </button>
    </div>
    <template v-if="start">
      <div class="chatbox__body" id="chat_box">
        <template v-for="(message,index) in messages">
          <div v-if="message.from != user" class="chatbox__body__message chatbox__body__message--left">
            <template v-if="message.faq_translation_id">
              <img src="/images/support_img.png" alt="Picture" class="chat-img">
              <div class="chat-bot-section">
                <a v-if="locale" :href="'/'+message.faq_translations.language.prefix+'/faq#'+ message.faq_translations.slug" class="answer-point">{{
                  message.faq_translations.question }}</a>
                <router-link v-else :to="'/'+message.faq_translations.language.prefix+'/faq#'+message.faq_translations.slug"  class="answer-point" tag="a">{{
                  message.faq_translations.question }}
                </router-link>
              </div>
            </template>
            <template v-else>
              <img src="/images/support_img.png" alt="Picture">
              <p>{{ message.message }}</p>
            </template>
          </div>
          <div v-else class="chatbox__body__message chatbox__body__message--right" :key='index+key'>
            <img v-if="photo" :src="photo" alt="Picture">
            <img v-else src="/images/men.jpg" alt="Picture">
            <p>{{ message.message }}</p>
          </div>
        </template>

        <template v-if="faqs.length">
          <div v-for="(faq,idx) in faqs" :key="'faq' + idx" class="chat-bot-section">
            <a v-if="locale" :href="'/'+locale+'/faq#'+faq.faq_transliations[0].slug">{{
              faq.faq_transliations[0].question }}</a>
            <router-link v-else :to="'/'+$store.getters.locale+'/faq#'+faq.faq_transliations[0].slug" tag="a">{{
              faq.faq_transliations[0].question }}
            </router-link>
          </div>
        </template>

<!--        <button @click="startTour">Start Tour</button>-->
      </div>

      <textarea class="chatbox__message" v-model="message"
                :placeholder="message_title ? message_title : $store.getters.t('message_title')"></textarea>
      <button class="send-message submit_button" @click="send()">{{
        send_title ? send_title : $store.getters.t('send')
        }}
      </button>
    </template>
    <template v-else>
      <form class="chatbox__credentials" @submit.prevent="startChat">
        <div class="form-group">
          <label for="inputName">{{ name ? name : $store.getters.t('name') }}:</label>
          <input type="text" class="form-control" name="name" v-model="form.name" id="inputName" required>
        </div>
        <div class="form-group">
          <label for="inputEmail">{{ email ? email : $store.getters.t('email') }}:</label>
          <input type="email" class="form-control" name="email" v-model="form.email" id="inputEmail" required>
        </div>
        <button type="submit" class="submit_button">{{ send_title ? send_title : $store.getters.t('send') }}</button>
      </form>
    </template>
  </div>
</template>

<script>

  import html2canvas from 'html2canvas';

  export default {
    name: "SupportComponent",
    props: {
      specialist_consultant: {
        type: String,
        default: null
      },
      message_title: {
        type: String,
        default: null
      },
      send_title: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null
      },
      email: {
        type: String,
        default: null
      },
      locale: {
        type: String,
        default: null
      },
    },
    mounted() {
      this.getUserForChat();
    },
    data() {
      return {
        start: false,
        user: null,
        chat: null,
        message: '',
        messages: [],
        faqs: [],
        key: 1,
        form: {
          email: '',
          name: '',
          locale: '',
          authenticated: false
        },
      }
    },
    watch: {
      '$store.state.authUser'(authenticated) {
        this.form.authenticated = authenticated;
        this.getUserForChat();
      },
      '$store.state.user'(user) {
        this.photo = user.photo;
        this.key++;
      }
    },
    methods: {
      async getUserForChat() {
        const res = await axios.get(`/api/getUser`);
        if (res.data.user) {
          this.form.authenticated = true;
          return this.startChat();
        } else if (localStorage.getItem('chatEmail')) {
          this.form.email = localStorage.getItem('chatEmail');
          this.form.name = localStorage.getItem('chatName');
          return this.startChat();
        } else {
          this.start = false;
          document.getElementById('chat-section').classList.remove('chatbox--messages');
        }
      },
      startChat() {
        if (!this.locale) {
          this.form.locale = this.$store.getters.locale;
        } else {
          this.form.locale = this.locale;
        }
        axios.post(`/${this.form.locale}/support/new/user`, this.form).then(res => {
          this.user = res.data.user;
          this.chat = res.data.chat;
          this.messages = res.data.messages;
          this.photo = res.data.photo;
          this.faqs = res.data.faqs;

          if (!this.form.authenticated) {
            localStorage.setItem('chatEmail', this.form.email);
            localStorage.setItem('chatName', this.form.name)
          }
          document.getElementById('chat-section').classList.add('chatbox--messages');
          window.Echo.channel('support-message-' + res.data.chat)
            .listen('SupportMessage', (e) => {
              document.getElementById('chat-section').classList.remove('chatbox--tray');
              this.messages.push(e);
              this.scrollBottom();
            }).listen('AutoScreenshot', (e) => {
            if (e.screen) {
              html2canvas(document.body).then((canvas) => {
                var base64image = canvas.toDataURL("image/png");
                axios.post(`/${this.form.locale}/support/screenshot/send`, {
                  image: base64image,
                  chat: this.chat
                }).then(res => {
                });
              });
            }
          });
          this.start = true;
          this.scrollBottom();
        });
      },
      send() {
        if (!this.message)
          return false;

        axios.post(`/${this.form.locale}/support/new/message`, {
          user: this.user,
          chat: this.chat,
          message: this.message
        }).then(res => {
          this.message = '';
          this.scrollBottom();
        });
      },
      scrollBottom() {
        setTimeout(function () {
          let chatBox = document.getElementById("chat_box");
          chatBox.scrollTop = chatBox.scrollHeight;
        }, 100);
      },
      hasClass(element, className) {
        return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
      },
      toggleChat() {
        document.getElementById('chat-section').classList.toggle('chatbox--tray')
      },
      b64toBlob(dataURI) {

        var byteString = atob(dataURI.split(',')[1]);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);

        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], {type: 'image/jpeg'});
      },
      startTour(){
        this.$tours['myTour'].start()
        console.log(this.$tours['myTour']);
      }
    },
  }
</script>

<style scoped>
.answer-point{
  border: 0;
  background: #00dda2;
  color: #fff;
  font-size: 14px;
  line-height: 18px;
  text-decoration: underline;
  width: 50%;
  position: relative;
  padding-top: 20px;
  margin-left: 20px;
  padding-left: 30px;
}
.answer-point:before{
  content: "";
  background: url("/images/arrow__go.png") no-repeat center center;
  background-size: 100%;
  width: 13px;
  height: 13px;
  position: absolute;
  top: 5px;
  right: 5px;
}
.answer-point:hover{
  text-decoration: none;
}
  .chat-img{
    z-index: 2;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/support/SupportComponent.vue